import React, { useState, useEffect, useContext, useMemo } from "react"

import { VOTING_STATUS } from "../../constants"
import {
  Container,
  ButtonGroup,
  VoteResult,
  VoteAmountItem,
  ButtonVoteWrapper,
  ButtonVote,
  TriangleUp,
  TriangleDown,
  LineUp,
  LineDown,
} from "./styles"
import { votingApi} from '../../helpers/fetcher'
import { dispatchCardAction } from '../../utils/postMessageUtils'
import {DataContext} from '../../store/GlobalState'
import VotingUp from '../VotingUp'
import VotingDown from '../VotingDown'


const VotingRadar = ({gid, rid, pid, groupRadarId}) => {
const { state: {groupRadarIdGlobalState: groupRadarIdGlobalStateState}, dispatch } = useContext(DataContext)

const groupRadarIdGlobalState = useMemo(() => {
  return groupRadarIdGlobalStateState ?? groupRadarId
}, [groupRadarIdGlobalStateState, groupRadarId])

  const [amountUps, setAmountUps] = useState(0)
  const [amountDowns, setAmountDowns] = useState(0)
  const [userVotingSelection, setUserVotingSelection] = useState(VOTING_STATUS.none)
  const [error, setError] = useState(null)
  const [userVotedAmount, setUserVotedAmount] = useState(0)

  //get radar phenomenon vote for current user
  const getVotesData  = async() => {
    const [{
      data: {
        plus_votes: userPlusVotes = 0,
        minus_votes: userMinusVotes = 0
      } = {}
    }, {
      data: {
        minus_votes: allMinusVotes = 0,
        plus_votes: allPlusVotes = 0
      }
    } = {}] = await Promise.all([ votingApi.getVote(groupRadarIdGlobalState || gid, rid, pid), votingApi.getVotes(groupRadarIdGlobalState ||  gid, rid, pid) ])

    if (userPlusVotes > 0) {
      setUserVotingSelection(VOTING_STATUS.up)
    } else if (userMinusVotes > 0) {
      setUserVotingSelection(VOTING_STATUS.down)
    } else {
      setUserVotingSelection(VOTING_STATUS.none)
    }

    setAmountUps(allPlusVotes)
    setAmountDowns(allMinusVotes)
  }

  const onUpHandler = async() => {
    try {
      if (String(userVotingSelection)  === String(VOTING_STATUS.up)) {
        setUserVotingSelection(VOTING_STATUS.none)
        setAmountUps(amountUps => amountUps - 1)

        await votingApi.deleteVote(groupRadarIdGlobalState || gid, rid, pid)
        dispatchCardAction('vote', { gid: groupRadarIdGlobalState || gid, radarId: rid, phenomenonId: pid, vote: 'none' })
      } else if (String(userVotingSelection)  === String(VOTING_STATUS.none)) {
        setUserVotingSelection(VOTING_STATUS.up)
        setAmountUps(amountUps => amountUps + 1)

        await votingApi.addVote(groupRadarIdGlobalState || gid, rid, pid, {up: true})
        dispatchCardAction('vote', { gid: groupRadarIdGlobalState || gid, radarId: rid, phenomenonId: pid, vote: 'up' })
      } else {
        setUserVotingSelection(VOTING_STATUS.up)
        setAmountUps(amountUps => amountUps + 1)
        setAmountDowns(amountDowns => amountDowns - 1)

        await votingApi.addVote(groupRadarIdGlobalState || gid, rid, pid, {up: true})
        dispatchCardAction('vote', { gid: groupRadarIdGlobalState || gid, radarId: rid, phenomenonId: pid, vote: 'up' })
      }

    } catch (error) {
      setError(error)
    }
  }

  const onDownHandler = async() => {
    try {
      if (String(userVotingSelection)  === String(VOTING_STATUS.down)) {
        setUserVotingSelection(VOTING_STATUS.none)
        setAmountDowns(amountDowns => amountDowns - 1)

        await votingApi.deleteVote(groupRadarIdGlobalState || gid, rid, pid)
        dispatchCardAction('vote', { gid: groupRadarIdGlobalState || gid, radarId: rid, phenomenonId: pid, vote: 'none' })
      } else if (String(userVotingSelection)  === String(VOTING_STATUS.none)) {
        setUserVotingSelection(VOTING_STATUS.down)
        setAmountDowns(amountDowns => amountDowns + 1)

        await votingApi.addVote(groupRadarIdGlobalState || gid, rid, pid, {up: false})
        dispatchCardAction('vote', { gid: groupRadarIdGlobalState || gid, radarId: rid, phenomenonId: pid, vote: 'down' })
      } else {
        setUserVotingSelection(VOTING_STATUS.down)
        setAmountUps(amountUps => amountUps - 1)
        setAmountDowns(amountDowns => amountDowns + 1)

        await votingApi.addVote(groupRadarIdGlobalState  || gid, rid, pid, {up: false})
        dispatchCardAction('vote', { gid: groupRadarIdGlobalState || gid, radarId: rid, phenomenonId: pid, vote: 'down' })
      }
    } catch (error) {
      setError(error)
    }
  }

  useEffect(() => {
    try {
        getVotesData()
    } catch (e) {
        setError(e)
    }
  }, [])

  return (
    <>
      <Container>
        <ButtonGroup>
          <ButtonVoteWrapper style={{
            marginRight: '0.25rem'
          }}>
            <VoteAmountItem>{amountUps}</VoteAmountItem>
            <div onClick={onUpHandler}>
              <VotingUp isAuthed={true}
                  isNewsBookMarked={userVotingSelection === VOTING_STATUS.up}/>
            </div>
            {/* <ButtonVote
              className={userVotingSelection === VOTING_STATUS.up ? "active" : ""}
              role="button"
              onClick={onUpHandler}
            >
              <TriangleUp></TriangleUp>
              <LineUp></LineUp>
            </ButtonVote> */}
          </ButtonVoteWrapper>
          <ButtonVoteWrapper >
            <VoteAmountItem>{amountDowns}</VoteAmountItem>
            {/* <ButtonVote
              className={userVotingSelection === VOTING_STATUS.down ? "active" : ""}
              role="button"
              onClick={onDownHandler}
            >
              <LineDown></LineDown>
              <TriangleDown></TriangleDown>
            </ButtonVote> */}

            <div onClick={onDownHandler}>
              <VotingDown isAuthed={true}
                  isNewsBookMarked={userVotingSelection === VOTING_STATUS.down}/>
            </div>
          </ButtonVoteWrapper>
        </ButtonGroup>
        <VoteResult>{amountUps - amountDowns}</VoteResult>
      </Container>
    </>
  );
};

export default VotingRadar
